import React, { useState } from "react";
import { TagsOutlined } from "@ant-design/icons";
import { Button, Modal, Select, message } from "antd";
import { useDispatch } from "react-redux";
import { bulkUpdateContactTags } from "../../redux/actions/contactsAction";

export default function BulkTagEditor({
  selectedIds,
  availableTags,
  fetchRecords,
  onDone,
}) {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addTags, setAddTags] = useState([]);
  const [removeTags, setRemoveTags] = useState([]);

  const tagOptions = (availableTags || [])
    .filter(Boolean)
    .map((tag) => ({ value: tag, label: tag }));

  const showModal = () => {
    setAddTags([]);
    setRemoveTags([]);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    if (addTags.length === 0 && removeTags.length === 0) {
      message.error("Choose at least one tag to add or remove.");
      return;
    }
    setLoading(true);
    dispatch(
      bulkUpdateContactTags({
        ids: selectedIds,
        addTags,
        removeTags,
      }),
    )
      .then((result) => {
        message.success(
          `Updated tags on ${result?.modifiedCount ?? 0} contact(s).`,
        );
        setLoading(false);
        setIsModalOpen(false);
        fetchRecords();
        onDone && onDone();
      })
      .catch((e) => {
        setLoading(false);
        message.error(e?.response?.data?.message || "Failed to update tags.");
      });
  };

  return (
    <>
      <Button
        icon={<TagsOutlined />}
        disabled={!selectedIds?.length}
        onClick={showModal}
      >
        Edit tags ({selectedIds?.length || 0} selected)
      </Button>
      {isModalOpen && (
        <Modal
          title="Bulk edit tags"
          open={isModalOpen}
          okText="Apply"
          onOk={handleOk}
          onCancel={handleCancel}
          confirmLoading={loading}
        >
          <p>
            Applying to {selectedIds.length} selected contact
            {selectedIds.length === 1 ? "" : "s"}.
          </p>
          <label>Add tags</label>
          <Select
            mode="tags"
            style={{ width: "100%", marginBottom: 16 }}
            placeholder="Tags to add"
            value={addTags}
            onChange={setAddTags}
            options={tagOptions}
          />
          <label>Remove tags</label>
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Tags to remove"
            value={removeTags}
            onChange={setRemoveTags}
            options={tagOptions}
          />
        </Modal>
      )}
    </>
  );
}
